import React from 'react';
import { footer } from '../data/tables';
export function Footer() {
  return <footer className="border-t border-brass/40 bg-paper" data-id="element-115" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8" data-id="element-116" data-mp="3ggk6ap6ov1ww">
        <p className="font-serif text-[22px] font-semibold text-ink" data-id="element-117" data-mp="32onl753ftsa0">{footer.brand}</p>
        <p className="mt-2 max-w-[34rem] text-[15px] leading-[1.6] text-slate" data-id="element-118" data-mp="36oy05797jt10">
          {footer.identity}
        </p>

        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-119" data-mp="3ug3c3bc12161">
          {footer.links.map(link => <li key={link} data-id="element-120" data-mp="37fu95czww38">
              <a href="#pricing" className="font-mono text-[11px] uppercase tracking-label text-slate transition-colors duration-150 ease-out hover:text-ink" data-id="element-121" data-mp="36msyjwt2ysh">
                {link}
              </a>
            </li>)}
        </ul>

        <div className="mt-10 space-y-2 border-t border-brass/25 pt-7" data-id="element-122" data-mp="29xvp07mdh3mo">
          <p className="max-w-[46rem] font-mono text-[10px] uppercase leading-[1.6] tracking-label text-slate/70" data-id="element-123" data-mp="2ezb99xgq7640">
            {footer.legalOne}
          </p>
          <p className="font-mono text-[10px] uppercase leading-[1.6] tracking-label text-slate/70" data-id="element-124" data-mp="3gah1hulpfl6d">
            {footer.legalTwo}
          </p>
        </div>
      </div>
    </footer>;
}